

export const districtItemStyles = {
  cursor: "pointer",
  fontSize: "14px",
  borderRadius: "20px",
  backgroundColor: "#f0f0f0",
  "&:hover": { backgroundColor: "#e0e0e0" },
};

export const districtBoxStyles = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1,
  p: 1,
};

export const buttonStyles = (theme) => ({
  borderRadius: 2,
  fontWeight: 500,
  fontSize: { xs: "0.8rem", sm: "0.7rem" },
  padding: { xs: "4px", sm: "6px" },
  fontFamily: "'Space Grotesk', sans-serif",
  background: theme.palette.mode === "light"
    ? "linear-gradient(135deg, #ff7eb3 0%, #ff758c 100%)"
    : "linear-gradient(135deg, #6e7f92 0%, #6c8097 100%)",
  transition: "0.3s",
  "&:hover": {
    background: theme.palette.mode === "light"
      ? "linear-gradient(135deg, #ff5177 0%, #ff3458 100%)"
      : "linear-gradient(135deg, #5b6c7e 0%, #5a6473 100%)",
    boxShadow: 2,
  },
});

export const gridStyles = {
  marginTop: 2,
  marginBottom: 2,
};
